module.exports = __webpack_public_path__ + "82a6926b70e5ba0664b9687740a0d6c3.jpg";